export default __webpack_public_path__ + "static/eew-logo-67bed70d41d78d8266caaccb38867f72.webp";